module.exports = __webpack_public_path__ + "static/media/FC1.a5643d47.jpg";